function _________(response) {
  return ('SOMOS UN EXITO!!');
}
module.exports.autentificacionEstados = function autentificacionEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case '_______':
        resolve(_______(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/autentificacion.js